import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";

import { type UserInfoBase } from "../../../../types";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface GroupMembersInfoState extends FetchingItemsState<UserInfoBase> {
  selectedIds: number[];
}

export const initialState: GroupMembersInfoState = {
  items: [],
  itemsCount: 0,
  selectedIds: [],
  isLoading: false,
  error: undefined,
};

const groupMembersInfoSlice = createFetchingItemsSlice({
  initialState,
  namePayload: { namespace: ReducerNamespaceTypes.People, entity: ReducerEntityPrefixTypes.AddGroup, name: "members" },
  reducers: {
    selectedItemsChanged: (state, action: PayloadAction<number[]>) => {
      state.selectedIds = action.payload;
    },
    resetSelectedItems(state) {
      state.selectedIds = [];
    },
  },
});

export const { fetchBegin, fetchSuccess, fetchFailure, selectedItemsChanged, resetSelectedItems, reset } =
  groupMembersInfoSlice.actions;

export default groupMembersInfoSlice.reducer;
